import wx from 'weixin-js-sdk'
import axios from 'axios'
import qs from 'qs'

const wxApi = {
  /**
  * [wxRegister 微信Api初始化]
  */
  wxRegister(callback) {
    var url = (window.location.href).split('#')[0];
    var api_url = "https://apiv2-app.ponhu.cn/Jssdk/index"
    var pram = qs.stringify({url: url});
    axios.post(api_url, pram).then(res => {
      if(res.data.code == 200) {
        var data = res.data.list;
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage'
          ]
        })
      }
    })
    wx.ready(function () {
      // 如果需要定制ready回调方法
      if (callback) {
        callback()
      }
    })
  },
  /**
  * [ShareTimeline 微信分享到朋友圈] 
  */
  ShareTimeline(option) {
    wx.onMenuShareTimeline({
      title: option.title,
      link: option.link,
      imgUrl: option.imgUrl,
      success() {
        // 用户成功分享后执行的回调函数
        option.success()
      },
      cancel() {
        // 用户取消分享后执行的回调函数
        option.error()
      }
    })
  },
  /**
  * [ShareAppMessage 微信分享给朋友]
  */
  ShareAppMessage(option) {
    wx.onMenuShareAppMessage({
      title: option.title,
      desc: option.desc,
      link: option.link,
      imgUrl: option.imgUrl,
      success() {
        // 用户成功分享后执行的回调函数
        option.success()
      },
      cancel() {
        // 用户取消分享后执行的回调函数
        option.error()
      }
    })
  },
}

export default wxApi
